module.exports = __webpack_public_path__ + "static/api_access-575b2ecbd1a1471eaaa1271536c437eb.png";